import React from "react";

const ContactUsForm = () => {
  return (
    <div className="p-6 flex justify-center">
      <div className="relative bg-white shadow-md rounded-lg w-96 p-6 border-l-4 hover:shadow-xl hover:border-blue-600 transition duration-300 ease-in-out">
        <div
          className="absolute top-0 left-0 w-full h-2 rounded-t-lg"
          style={{ backgroundColor: "#36A2EB" }}
        ></div>

        <h2 className="text-lg font-bold text-gray-800 mb-6 flex items-center">
          Contact Us
        </h2>

        <form>
          {/* Name */}
          <div className="mb-4">
            <label
              htmlFor="name"
              className="block text-gray-600 text-sm font-semibold mb-2"
            >
              Name
            </label>
            <input
              type="text"
              id="name"
              placeholder="Your Name"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* Phone Number */}
          <div className="mb-4">
  <label
    htmlFor="phone"
    className="block text-gray-600 text-sm font-semibold mb-2"
  >
    Phone Number
  </label>
  <div className="flex items-center gap-2">
    <select
      className="border border-gray-300 rounded-lg px-2 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none w-1/4"
    >
      <option value="+1">+1 (US)</option>
      <option value="+91">+91 (India)</option>
      <option value="+44">+44 (UK)</option>
      <option value="+61">+61 (Australia)</option>
    </select>
    <input
      type="tel"
      id="phone"
      placeholder="123 456 7890"
      className="flex-1 border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none w-3/4"
    />
  </div>
</div>


          {/* Email */}
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-gray-600 text-sm font-semibold mb-2"
            >
              Email
            </label>
            <input
              type="email"
              id="email"
              placeholder="you@example.com"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* Subject */}
          <div className="mb-6">
            <label
              htmlFor="subject"
              className="block text-gray-600 text-sm font-semibold mb-2"
            >
              Subject
            </label>
            <input
              type="text"
              id="subject"
              placeholder="Your Subject"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* Submit Button */}
          <div className="mt-4">
            <button
              type="submit"
              className="w-full bg-primaryOrange text-white py-2 px-4 rounded-lg font-semibold hover:bg-orange-600 transition"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUsForm;
